module.exports = __webpack_public_path__ + "static/1-7df857211b6b1e21a35871bafcb9334e.webm";